// extracted by mini-css-extract-plugin
export default {"tableCell":"YaerlyInvestmentSummaryDisplay_tableCell__oV3ue"};